<template lang="html">
  <div class="cart-page min-h-[60vh] flex-1 bg-elevated">
    <div class="mx-auto w-full max-w-(--ui-container) px-4 py-6 sm:py-8">
      <CartView />
    </div>
  </div>
</template>

<script setup lang="ts">
import CartView from '../../components/Info/CartView.vue'

definePageMeta({
  name: 'CartIndex',
})
</script>
